import { z } from 'zod';

export const WorldModelDocSchema = z.object({
  id: z.string(),
  content: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const WorldModelDocListItemSchema = WorldModelDocSchema.pick({
  id: true,
  created_at: true,
  updated_at: true,
});

export type WorldModelDoc = z.infer<typeof WorldModelDocSchema>;
export type WorldModelDocListItem = z.infer<typeof WorldModelDocListItemSchema>;

// Graph visualization types
export interface GraphEntity {
  id: string;
  name: string | null;
  type: string;
  properties: Record<string, unknown>;
  content: string | null;
}

export interface GraphRelationshipContext {
  type: string;
  text: string;
  timestamp: string;
}

export interface GraphRelationship {
  id: string;
  source: string;
  target: string;
  source_name: string | null;
  target_name: string | null;
  semantic: string | null;
  context: GraphRelationshipContext[];
  metadata: Record<string, unknown>;
}

export interface GraphData {
  entities: GraphEntity[];
  relationships: GraphRelationship[];
}

export type GraphSelectedNode = {
  kind: 'node';
  entity: GraphEntity;
  color: string;
};
export type GraphSelectedEdge = { kind: 'edge'; rel: GraphRelationship };
export type GraphSelection = GraphSelectedNode | GraphSelectedEdge | null;

// KG Agent types
export interface KGAgentToolCall {
  name: string;
  arguments: Record<string, unknown>;
  result: string;
}

export interface KGAgentTextBlock {
  type: 'text';
  content: string;
}

export interface KGAgentThoughtBlock {
  type: 'thought';
  content: string;
}

export interface KGAgentToolCallBlock {
  type: 'tool_call';
  toolCall: KGAgentToolCall;
}

export interface KGAgentInterruptedBlock {
  type: 'interrupted';
}

export type KGAgentMessageBlock =
  | KGAgentTextBlock
  | KGAgentThoughtBlock
  | KGAgentToolCallBlock
  | KGAgentInterruptedBlock;

export interface KGAgentMessage {
  role: 'user' | 'assistant';
  content: string;
  blocks: KGAgentMessageBlock[];
  timestamp: number;
}

export interface KGAgentSession {
  messages: KGAgentMessage[];
  createdAt: number;
}
